import { PrimitiveAtom } from "jotai";
import { PercentCell, PercentCellProps } from "./PercentCell";

import { GrowthCell as GrowthCellType } from "@/financeModels/owasco/types";
import { Group } from "@mantine/core";
import { Wrapper } from "./cell/Wrapper";

type GrowthCellProps = Omit<PercentCellProps, "atom"> & {
  atom: PrimitiveAtom<GrowthCellType>;
};

export const GrowthCell = (props: GrowthCellProps) => {
  return (
    <Wrapper style={{ background: "#DEE2E6" }}>
      <Group w={"100%"} px={16} bg="gray.3">
        <PercentCell
          justifyContent={"center"}
          style={{
            //boxShadow: `#DEE2E6 ${padding}px 0 0 0, #DEE2E6 -${padding}px 0 0 0`,
            background: "transparent",
            //borderRight: `${padding}px solid #DEE2E6`,
            //borderLeft: `${padding}px solid #DEE2E6`,
          }}
          {...props}
        />
      </Group>
    </Wrapper>
  );
};
